"use strict";
exports.__esModule = true;
exports.iconSizes = void 0;
exports.iconSizes = {
    xxSmall: "14px",
    xSmall: "16px",
    small: "20px",
    medium: "24px",
    large: "32px",
    xLarge: "48px",
    xxLarge: "64px"
};
//# sourceMappingURL=constants.js.map